import { Event } from "consts/auth";
import { useSimpleRequest, type RequestSettings } from "hooks/useRequest";
import { publish } from "util/custom-event";
import { verify as verify2FA, resend2FACode } from "features/auth/api";
import { removeLegacyTrustToken } from "features/auth/helpers";
import type { TwoFactorVerifyResponse } from "features/auth/types";
import type { Verify2FA } from "ui/forms/Auth";

export default function useVerify2FA() {
    const request = useSimpleRequest({
        shouldNotifyOnSuccess: true
    });

    const resend = ({ onSuccess }: Pick<RequestSettings, 'onSuccess'>) =>
        request(resend2FACode, {
            onSuccess
        });

    const verify: Verify2FA.TwoFactorCodeFormProps['onSubmit'] = ({
        twoFactorCode,
        withTrustToken
    }, helpers) => request<TwoFactorVerifyResponse['data']>(() => verify2FA({
        // The API issues a trust token whenever the key is present, even if false
        ...(withTrustToken && { withTrustToken }),
        twoFactorCode: twoFactorCode!
    }), {
        onSuccess: ({ data }) => {
            helpers!.resetForm();
            // 2FA was required, so the legacy cookie is no longer valid;
            // the API sets the HttpOnly TID cookie when the device is trusted
            removeLegacyTrustToken();
            publish(Event.GetUser, data);
        }
    });

    return {
        verify,
        resend
    };
};
